import { useEffect, useState } from 'react'
import Header from '../components/Header'
import Menu from '../components/Menu'
import { useAllContext } from '../context/AllContext'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select';
import { useTranslation } from 'react-i18next'
import CreatableSelect from "react-select/creatable";
import { useNavigate, useParams } from 'react-router-dom'

const UpdatePost = () => {
    const { t } = useTranslation()
    const params = useParams();
    const navigate = useNavigate();
    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const {
        getMediaType, mediaType,
        getTagCategoryKeyword, tagCategoryKeyword,
        getSingleUserPost, singleUserPost
    } = useAllContext()

    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState({
        title: "",
        mediaType: "",
        mediaName: "",
        mediaTypeOther: "",
        tools: "",
        tags: [],
        creationDate: "",
        description: "",
        collaboration: "",
        intendedMessage: "",
        projectType: "",
        skillLevel: "",
        visibilitySettings: "",
        licensing: "",
        image: null
    });
    
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setInputValue({
            ...inputValue,
            [name]: value
        })
    }

    const [preview, setPreview] = useState(null);

    const handleImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setInputValue((prev) => ({
                ...prev,
                image: file,
            }));
            setPreview(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        setInputValue({
            ...inputValue,
            mediaTypeOther: ""
        })
    }, [inputValue.mediaType])

    useEffect(() => {
        if (singleUserPost?._id) {
            setInputValue({
                title: singleUserPost.title || "",
                mediaType: singleUserPost.mediatype?._id || "",
                mediaName: singleUserPost.mediatype?.name || "",
                mediaTypeOther: "",
                tools: singleUserPost.software_tools || "",
                tags: singleUserPost.tags?.map(tag => ({
                    value: tag._id,
                    label: tag.name
                })) || [],
                creationDate: singleUserPost.date_creation
                    ? new Date(singleUserPost.date_creation).toISOString().split("T")[0]
                    : "",
                description: singleUserPost.description || "",
                collaboration: singleUserPost.collaboration_credits || "",
                intendedMessage: singleUserPost.intended_message || "",
                projectType: singleUserPost.project_context || "",
                skillLevel: singleUserPost.skill_level || "",
                visibilitySettings: singleUserPost.visibility_settings || "",
                licensing: singleUserPost.licensing_reuse_rights || "",
                image: null
            });

            setPreview(`${process.env.REACT_APP_API_URL}/${singleUserPost.image}`);
        }
        }, [singleUserPost]);

    
    const [errors, setErrors] = useState({});
    const validate = () => {
        let errors = {};

        if (!inputValue.title) {
            errors.title = "Title is required"
        }
        if (!inputValue.mediaType) {
            errors.mediaType = "Media type is required";
        }

        if (inputValue.mediaType === "other" && !inputValue.mediaTypeOther) {
            errors.mediaTypeOther = "Please specify media type";
        }

        if (!inputValue.mediaName) {
            errors.mediaName = "Media name is required";
        }

        if (!inputValue.tools) {
            errors.tools = "Tools are required";
        }

        if (!inputValue.tags || inputValue.tags.length === 0) {
            errors.tags = "At least one tag is required";
        }

        if (!inputValue.creationDate) {
            errors.creationDate = "Creation date is required";
        }

        if (!inputValue.description) {
            errors.description = "Description is required";
        }

        if (!inputValue.collaboration) {
            errors.collaboration = "Collaboration field is required";
        }

        if (!inputValue.visibilitySettings) {
            errors.visibilitySettings = "Please select visibility setting";
        }

        if (!inputValue.licensing) {
            errors.licensing = "Please select licensing option";
        }

        if (inputValue.image) {
            const file = inputValue.image;
            if (!file.type.startsWith("image/")) {
                errors.image = "Only image files are allowed.";
            }
        }
        
        return errors;
    };

    const formSubmit = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);
        
        const formData = new FormData();
        formData.append('postid', params.postId);
        formData.append('user', limitsUser._id);
        formData.append('title', inputValue.title);
        formData.append('mediatype', inputValue.mediaType);
        if (inputValue.mediaType === "other") {
            formData.append('other', inputValue.mediaTypeOther);
        }
        formData.append('software_tools', inputValue.tools);
        formData.append("tags", JSON.stringify(
            inputValue.tags.map(tag => tag.value)
        ));
        formData.append('date_creation', inputValue.creationDate);
        formData.append('description', inputValue.description);
        formData.append('collaboration_credits', inputValue.collaboration);
        formData.append('intended_message', inputValue.intendedMessage);
        formData.append('project_context', inputValue.projectType);
        formData.append('skill_level', inputValue.skillLevel);
        formData.append('visibility_settings', inputValue.visibilitySettings);
        formData.append('licensing_reuse_rights', inputValue.licensing);
        {
            inputValue.image && formData.append("image", inputValue.image);
        }
        
        if (Object.keys(formErrors).length === 0) {
            setLoading(true);
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/user-post-update`, formData, {
                    headers: {
                        Authorization: `${limitsUser?.token}`
                    }
                })
                const data = await response.data

                if(data.status === 1){
                    toast.success(data.message)
                    getMediaType(limitsUser?.token)
                    getTagCategoryKeyword(limitsUser?.token)
                    navigate(`/post-details/${params.postId}`)
                } else {
                    toast.error(data.message)
                }

            } catch (error) {
                console.log('Error:', error);
            } finally {
                setLoading(false);
            }
        }
    }

    const [loadingPage, setLoadingPage] = useState(true);
    useEffect(() => {
        if (params && limitsUser) {
            getSingleUserPost(limitsUser?.token, params.postId)
            .finally(() => {
                setLoadingPage(false);
            });
        }
    }, [params]);
    
    useEffect(() => {
        if (limitsUser) {
            getMediaType(limitsUser?.token)
            getTagCategoryKeyword(limitsUser?.token)
        }
    }, [])
    

    return (
        <>
            <div className='main-content'>
                <Header page={"profile2"} title={"Update Post"} backpage={`/post-details/${params.postId}`} />

                <div className='padding2'>
                    <div className='container'>
                        {loadingPage ? (
                            <div>
                                <p className='py-5 text-center'>Loading...</p>
                            </div>
                            ) : (
                            <div className='profile-form'>
                                <form action="" className='form form1' onSubmit={formSubmit}>
                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Image")}</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="image"
                                            accept="image/*"
                                            onChange={handleImage}
                                        />
                                        {errors.image && <p className="error-text">{errors.image}</p> }

                                        {preview && (
                                            <div className="mt-3">
                                            <p>Preview:</p>
                                            <img
                                                src={preview}
                                                alt="preview"
                                                className='rounded-2'
                                                crossOrigin="anonymous"
                                                style={{ maxWidth: "200px" }}
                                            />
                                            </div>
                                        )}
                                    </div>

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Title")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="title"
                                            value={inputValue.title}
                                            onChange={inputHandler}
                                            placeholder={t("Enter here")}
                                        />
                                        {errors.title && <p className="error-text">{errors.title}</p> }
                                    </div>

                                    <div className='mb-3 react-select1'>
                                        <label className='form-label mb-0'>{t("Media Type")}</label>
                                        <Select
                                            options={[
                                                ...mediaType?.map((item) => ({
                                                    value: item._id,
                                                    label: item.name,
                                                })),
                                                { value: "other", label: "Other" }
                                            ]}
                                            name="mediaType"
                                            value={
                                                inputValue.mediaType
                                                    ? { value: inputValue.mediaType, label: inputValue.mediaName }
                                                    : null
                                            }
                                            onChange={(selected) => {
                                                setInputValue((prev) => ({
                                                    ...prev,
                                                    mediaType: selected.value,
                                                    mediaName: selected.label,
                                                }));
                                            }}
                                            placeholder={`${t('Please Select')}`}
                                        />
                                        {errors.mediaType && <p className="error-text">{errors.mediaType}</p> }
                                    </div>

                                    {
                                        inputValue.mediaType === "other" && <div className='mb-3'>
                                            <label className='form-label mb-0'>{t("Other Media Type")}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="mediaTypeOther"
                                                value={inputValue.mediaTypeOther}
                                                onChange={inputHandler}
                                                placeholder={t("Enter here")}
                                            />
                                            {errors.mediaTypeOther && <p className="error-text">{errors.mediaTypeOther}</p> }
                                        </div>
                                    }

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Tools / Software Used")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="tools"
                                            value={inputValue.tools}
                                            onChange={inputHandler}
                                            placeholder={t("Enter here")}
                                        />
                                        {errors.tools && <p className="error-text">{errors.tools}</p> }
                                    </div>

                                    <div className='mb-3 react-select1'>
                                        <label className='form-label mb-0'>{t("Tags / Categories / Keywords")}</label>
                                        <CreatableSelect
                                            options={tagCategoryKeyword?.map((item) => ({
                                                value: item._id,
                                                label: item.name
                                            }))}
                                            name="tags"
                                            value={
                                                inputValue.tags
                                                    ? inputValue.tags.map(tag => ({
                                                        value: tag.value,
                                                        label: tag.label
                                                    }))
                                                    : null
                                            }
                                            onChange={(selected) => {
                                                setInputValue((prev) => ({
                                                    ...prev,
                                                    tags: selected
                                                        ? selected.map(item => ({
                                                            value: item.value,
                                                            label: item.label,
                                                        }))
                                                        : [],
                                                }));
                                            }}
                                            isMulti
                                            placeholder={`${t('Please Select or Type & Press Enter')}`}
                                        />
                                        {errors.tags && <p className="error-text">{errors.tags}</p> }
                                    </div>


                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Date of Creation")}</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="creationDate"
                                            value={inputValue.creationDate}
                                            onChange={inputHandler}
                                            placeholder=""
                                        />
                                        {errors.creationDate && <p className="error-text">{errors.creationDate}</p> }
                                    </div>

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Description / Artist Statement")}</label>
                                        <textarea 
                                            className="form-control h-auto"
                                            name="description" 
                                            value={inputValue.description}
                                            onChange={inputHandler}
                                            rows={4}
                                            placeholder={t("Enter here")}
                                        ></textarea>
                                        {errors.description && <p className="error-text">{errors.description}</p> }
                                    </div>

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Collaboration / Credits")} ({t("if applicable")})</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="collaboration"
                                            value={inputValue.collaboration}
                                            onChange={inputHandler}
                                            placeholder={t("Enter here")}
                                        />
                                        {errors.collaboration && <p className="error-text">{errors.collaboration}</p> }
                                    </div>

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Intended Message / Theme")} ({t("optional")})</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="intendedMessage"
                                            value={inputValue.intendedMessage}
                                            onChange={inputHandler}
                                            placeholder={t("Enter here")}
                                        />
                                        {errors.intendedMessage && <p className="error-text">{errors.intendedMessage}</p> }
                                    </div>

                                    <div className='mb-3 react-select1'>
                                        <label className='form-label mb-0'>{t("Project Type or Usage Context")} ({t("optional")})</label>
                                        <Select
                                            options={[
                                                { value: 'School Project', label: 'School Project' },
                                                { value: 'Personal Practice', label: 'Personal Practice' },
                                                { value: 'Competition Entry', label: 'Competition Entry' },
                                                { value: 'Commissioned Work', label: 'Commissioned Work' },
                                                { value: 'Workshop Result', label: 'Workshop Result' }
                                            ]}
                                            name="projectType"
                                            value={
                                                inputValue.projectType
                                                    ? { value: inputValue.projectType, label: inputValue.projectType }
                                                    : null
                                            }
                                            onChange={(selected) => {
                                                setInputValue((prev) => ({
                                                    ...prev,
                                                    projectType: selected.value,
                                                }));
                                            }}
                                            placeholder={`${t('Please Select')}`}
                                        />
                                        {errors.projectType && <p className="error-text">{errors.projectType}</p> }
                                    </div>

                                    <div className='mb-3 react-select1'>
                                        <label className='form-label mb-0'>{t("Skill Level")} ({t("optional")})</label>
                                        <Select
                                            options={[
                                                { value: 'Beginner', label: 'Beginner' },
                                                { value: 'Intermediate', label: 'Intermediate' },
                                                { value: 'Advanced', label: 'Advanced' },
                                                { value: 'Professional', label: 'Professional' }
                                            ]}
                                            name="skillLevel"
                                            value={
                                                inputValue.skillLevel
                                                    ? { value: inputValue.skillLevel, label: inputValue.skillLevel }
                                                    : null
                                            }
                                            onChange={(selected) => {
                                                setInputValue((prev) => ({
                                                    ...prev,
                                                    skillLevel: selected.value,
                                                }));
                                            }}
                                            placeholder={`${t('Please Select')}`}
                                        />
                                        {errors.skillLevel && <p className="error-text">{errors.skillLevel}</p> }
                                    </div>

                                    <div className='mb-3 react-select1'>
                                        <label className='form-label mb-0'>{t("Visibility Settings")}</label>
                                        <Select
                                            options={[
                                                { value: 'Public', label: 'Public' },
                                                { value: 'Judges/Sponsors Only', label: 'Judges/Sponsors Only' },
                                                { value: 'Private', label: 'Private' }
                                            ]}
                                            name="visibilitySettings"
                                            value={
                                                inputValue.visibilitySettings
                                                    ? { value: inputValue.visibilitySettings, label: inputValue.visibilitySettings }
                                                    : null
                                            }
                                            onChange={(selected) => {
                                                setInputValue((prev) => ({
                                                    ...prev,
                                                    visibilitySettings: selected.value,
                                                }));
                                            }}
                                            placeholder={`${t('Please Select')}`}
                                        />
                                        {errors.visibilitySettings && <p className="error-text">{errors.visibilitySettings}</p> }
                                    </div>

                                    <div className='mb-3'>
                                        <label className='form-label mb-0'>{t("Licensing / Reuse Rights")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="licensing"
                                            value={inputValue.licensing}
                                            onChange={inputHandler}
                                            placeholder={t("Enter here")}
                                        />
                                        {errors.licensing && <p className="error-text">{errors.licensing}</p> }
                                    </div>

                                    <div className='mt-4 sticky-bottom' style={{bottom: "70px"}}>
                                        <button
                                            className='btn btn1 w-100 mt-4'
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? "Updating..." : "Update"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )}
                        
                    </div>
                </div>

                <Menu />
            </div>
        </>
    )
}

export default UpdatePost
